
<script>
import New from './New1'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
